import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {openInBrowser} from '../../../../../srcCommon/browser/openInBrowser';
import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {LocalPreferencesFlagsEnum} from '../../../../models/api/localPreferencesModel';
import {
  FetchSourcesEnum,
  getCacheStats,
  getPrefetchStats,
  getRecentTraceEvents,
  TraceEvent,
  TraceEventTypesEnum,
} from '../../../../services/trace';
import {getCompanyRegion} from '../../../../store/data/company/companySelectors';
import {toggleFlagAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {getFlags} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {getHasOfflineCache} from '../../../../store/featureFlags/featureFlagsSelectors';
import {TraceDropdown} from './traceDropdown';

/*
 * Selectors.
 */

const getIsTraceEnabled = createSelector(
  getFlags,
  (flags) => flags[LocalPreferencesFlagsEnum.TRACE_PERFORMANCE],
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<{}>()(() => ({
  companyRegion: getCompanyRegion,
  hasOfflineCache: getHasOfflineCache,
  isTraceEnabled: getIsTraceEnabled,
}));

export const TraceDropdownContainer = connect(
  mapStateToProps,
  {toggleFlagAction},
  (stateProps, dispatchProps, ownProps) => {
    const traceEvents = getRecentTraceEvents();
    const cacheStats = getCacheStats();
    const prefetchStats = getPrefetchStats();

    const toggleTrace = () =>
      dispatchProps.toggleFlagAction(LocalPreferencesFlagsEnum.TRACE_PERFORMANCE, !stateProps.isTraceEnabled);

    const openEventProfile: HandlerOf<TraceEvent> = (traceEvent) => {
      if (traceEvent.type === TraceEventTypesEnum.INITIAL_APP_LOAD) {
        // TODO: Add Load Event to Trace Dropdown.
        return;
      }

      const {fetchInfos} = traceEvent.event;

      if (!fetchInfos || fetchInfos.source !== FetchSourcesEnum.SERVER) {
        return;
      }

      const {taskId} = fetchInfos;

      if (!taskId) {
        console.log('This event has no profiling information', event);
        return;
      }

      const traceUrl = `https://hq.frontapp.com/trace/${taskId}?region=${stateProps.companyRegion}`;
      console.log(traceUrl);
      openInBrowser(traceUrl);
    };

    return {
      ...ownProps,
      ...stateProps,
      traceEvents,
      cacheStats,
      prefetchStats,
      toggleTrace,
      openEventProfile,
    };
  },
)(TraceDropdown);
